import enMessages from '../locales/en_US.json';
import {enUS} from '@mui/material/locale';

const EnLang = {
  messages: {
    ...enMessages,
  },
  muiLocale: enUS,
  locale: 'en-US',
};
export default EnLang;
